export default {
  name: 'Modal',
  data: function () {
    return {
      modalTitle: 'Did we see you at the Adobe Summit conference this year?',
      showBtns: true
    }
  },
  mounted () {
    document.body.addEventListener('keyup', e => {
      if (e.keyCode === 27) {
        this.$emit('close')
      }
    })
  },
  methods: {
    handleModalShowed: function () {
      localStorage.showModal = false
      this.handleModalHide()
    },
    handleModalHide: function () {
      this.$emit('close')
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/Modal/Modal.js